// Cierre del día: ayudas de la pantalla. Las cifras las calcula la base (cash_day_summary, 20261009a_orders_accounting_bridge.sql) con el día en hora de Colombia.
import { PAYMENT_METHOD_LABELS } from './sales';

export const SOURCE_LABELS = { pedidos: 'Pedidos', citas: 'Citas', ventas: 'Ventas y cotizaciones' };

// Hoy en Colombia (YYYY-MM-DD), sin importar la zona horaria del navegador.
export const bogotaToday = (now = new Date()) => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);

export const shiftDay = (day, n) => {
  const [y, m, d] = String(day).split('-').map(Number);
  const t = new Date(Date.UTC(y, m - 1, d + n));
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, '0')}-${String(t.getUTCDate()).padStart(2, '0')}`;
};

export const dayLabel = (day) => {
  const [y, m, d] = String(day).split('-').map(Number);
  return new Intl.DateTimeFormat('es-CO', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(Date.UTC(y, m - 1, d)));
};

export const methodLabel = (m) => PAYMENT_METHOD_LABELS[m] || m || 'Sin medio';

// Contado − esperado, en centavos para no arrastrar decimales de punto flotante.
export const cashDifference = (counted, expected) => (Math.round(Number(counted) * 100) - Math.round(Number(expected) * 100)) / 100 + 0;

export const differenceInfo = (diff) => {
  if (diff === 0) return { label: 'Cuadra', tone: 'text-emerald-400' };
  return diff > 0 ? { label: 'Sobra', tone: 'text-amber-300' } : { label: 'Falta', tone: 'text-rose-300' };
};

// Comprobación previa en pantalla (la base vuelve a validar todo).
export const checkClose = ({ counted, expected, notes }) => {
  if (counted === '' || counted == null || !Number.isFinite(Number(counted))) return 'Escribe el efectivo contado (0 si no hubo).';
  const n = Number(counted);
  if (n < 0) return 'El efectivo contado no puede ser negativo.';
  if (Math.abs(n * 100 - Math.round(n * 100)) > 1e-6) return 'El efectivo admite hasta 2 decimales.';
  if (cashDifference(n, expected) !== 0 && !String(notes ?? '').trim()) return 'El efectivo contado no coincide con el esperado: explica la diferencia en las notas.';
  return null;
};
